/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PackageFileWithDownloadSchema } from './PackageFileWithDownloadSchema';
import {
    PackageFileWithDownloadSchemaFromJSON,
    PackageFileWithDownloadSchemaFromJSONTyped,
    PackageFileWithDownloadSchemaToJSON,
} from './PackageFileWithDownloadSchema';

/**
 * 
 * @export
 * @interface PackageWithDownloadSchema
 */
export interface PackageWithDownloadSchema {
    /**
     * 
     * @type {number}
     * @memberof PackageWithDownloadSchema
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PackageWithDownloadSchema
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PackageWithDownloadSchema
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof PackageWithDownloadSchema
     */
    condaName?: string;
    /**
     * 
     * @type {string}
     * @memberof PackageWithDownloadSchema
     */
    clientVersion?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PackageWithDownloadSchema
     */
    include: boolean;
    /**
     * 
     * @type {string}
     * @memberof PackageWithDownloadSchema
     */
    source: PackageWithDownloadSchemaSourceEnum;
    /**
     * 
     * @type {PackageFileWithDownloadSchema}
     * @memberof PackageWithDownloadSchema
     */
    file?: PackageFileWithDownloadSchema;
    /**
     * 
     * @type {string}
     * @memberof PackageWithDownloadSchema
     */
    channel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PackageWithDownloadSchema
     */
    requested?: boolean;
}


/**
 * @export
 */
export const PackageWithDownloadSchemaSourceEnum = {
    Pip: 'pip',
    Conda: 'conda'
} as const;
export type PackageWithDownloadSchemaSourceEnum = typeof PackageWithDownloadSchemaSourceEnum[keyof typeof PackageWithDownloadSchemaSourceEnum];


/**
 * Check if a given object implements the PackageWithDownloadSchema interface.
 */
export function instanceOfPackageWithDownloadSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "specifier" in value;
    isInstance = isInstance && "include" in value;
    isInstance = isInstance && "source" in value;

    return isInstance;
}

export function PackageWithDownloadSchemaFromJSON(json: any): PackageWithDownloadSchema {
    return PackageWithDownloadSchemaFromJSONTyped(json, false);
}

export function PackageWithDownloadSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PackageWithDownloadSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'specifier': json['specifier'],
        'condaName': !exists(json, 'conda_name') ? undefined : json['conda_name'],
        'clientVersion': !exists(json, 'client_version') ? undefined : json['client_version'],
        'include': json['include'],
        'source': json['source'],
        'file': !exists(json, 'file') ? undefined : PackageFileWithDownloadSchemaFromJSON(json['file']),
        'channel': !exists(json, 'channel') ? undefined : json['channel'],
        'requested': !exists(json, 'requested') ? undefined : json['requested'],
    };
}

export function PackageWithDownloadSchemaToJSON(value?: PackageWithDownloadSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'specifier': value.specifier,
        'conda_name': value.condaName,
        'client_version': value.clientVersion,
        'include': value.include,
        'source': value.source,
        'file': PackageFileWithDownloadSchemaToJSON(value.file),
        'channel': value.channel,
        'requested': value.requested,
    };
}

